// extracted by mini-css-extract-plugin
module.exports = {"copy":"Copy_copy__WMlyp"};